import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Key, useState } from 'react'
import { AIMenu } from 'common/Prose/Toolbar/AIMenu/AIMenu'
import { PlagiarismDetection } from 'components/DocRightPanelWrapper/Panels/PlagiarismDetectionPanel/PlagiarismDetection'
import SEOAnalysis from 'components/SEOAnalysis/SEOAnalysis'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { DrawerProps } from 'components/Drawer/Root'

const HeadingMap = new Map([
  ['plagiarismCheck', 'Plagiarism Check'],
  ['seoAnalysis', 'SEO Analysis'],
])

export const AIMenuDrawer = observer((props: DrawerProps) => {
  const [subMenu, setSubMenu] = useState<string | undefined>(undefined)
  const { drawersStore } = useRootStore()

  const onAction = (action: Key) => {
    switch (action) {
      case 'plagiarismCheck':
        return setSubMenu('plagiarismCheck')
      case 'seoAnalysis':
        return setSubMenu('seoAnalysis')
    }
    drawersStore.closeDrawer()
  }

  return (
    <Drawer.Root {...props} onClose={() => setSubMenu(undefined)}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              {subMenu ? <Drawer.Back onPress={() => setSubMenu(undefined)} /> : <div />}
              <Drawer.Title asChild>
                <Heading level={5}>{subMenu ? HeadingMap.get(subMenu) : 'AI Actions & Tools'}</Heading>
              </Drawer.Title>
              <Drawer.Close position="right" />
            </Drawer.Top>

            <Drawer.Container>
              {!subMenu && <AIMenu onAction={onAction} menuType="tray" />}
              {subMenu === 'plagiarismCheck' && <PlagiarismDetection />}
              {subMenu === 'seoAnalysis' && <SEOAnalysis />}
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
